import { OpportunityType } from "@/graphql"

const opportunityTypes = new Set<string>(Object.values(OpportunityType))

export function parseOpportunityType(value: unknown): OpportunityType | null {
	if (typeof value !== "string" || !opportunityTypes.has(value)) {
		return null
	}

	return value as OpportunityType
}

export function isOpportunityType(value: unknown): value is OpportunityType {
	return parseOpportunityType(value) !== null
}
